/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {AbstractResourceService} from "@irian-ro/abstract-resource";
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class DelBusinessProfileResourceService extends AbstractResourceService<any,any,any,any>{

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('businessProfileUrl'),
      undefined,
      undefined
    );
  }

  getPublicAndPartnerBusinessProfilesByLegalEntityUuids(value: { clientLe: string | undefined | null ; vendorLe: string |null } | null): Observable<any[]> {
    return <Observable<any[]>>this.httpClient?.get(`${this.url}/partners/${value?.clientLe}/${value?.vendorLe}`);
  }

  getPartnerBusinessProfilesByOwner() {
    return <Observable<any[]>>this.httpClient?.get(`${this.url}/partners`);
  }

  getPartnerBusinessProfileByPartnerLe( partnerLegalEntityUuid : string): Observable<any>{
    return this.httpClient?.get(`${this.url}/partner/${partnerLegalEntityUuid}`);
  }
}
